<template>
  <div>
    <navbar />
    <div class="mt-5 pt-5">
      <router-view />
      <fab :draggable="true" />
    </div>
  </div>
</template>

<script>
import 'bootstrap';

// components
import Navbar from './components/Navbar.vue';
import Fab from 'custom-floating-action-button';

export default {
  name: 'PublicLayout',
  components: {
    Navbar,
    Fab,
  },
};
</script>

<style>
html {
  height: 100% !important;
}

body {
  height: 100% !important;
}
</style>
